'use client';

import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import { BrtIgnore } from 'react-bunja-devtools/brt';

import { enabledPrexDevTool } from '@flipster/features/src/prex-dev-tool';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { isBuild } from '@flipster/utils/env-helper';

const DevMode = dynamic(() => import('./dev-mode'), { ssr: false });

let DevTools: ComponentType | null = null;
if (!isBuild) {
  DevTools = dynamic(() => import('./dev-tools'), { ssr: false });
}

let PrexDevTool: ComponentType | null = null;
if (enabledPrexDevTool()) {
  PrexDevTool = dynamic(() => import('@flipster/features/src/prex-dev-tool').then((i) => i.PrexDevTool), {
    ssr: false,
  });
}

const DevClient = () => {
  const isMounted = useMounted();

  if (!isMounted) return null;
  return (
    <BrtIgnore>
      <DevMode />
      {DevTools && <DevTools />}
      {PrexDevTool && <PrexDevTool />}
    </BrtIgnore>
  );
};

export default DevClient;
